// src/pages/PrivacyPolicyPage.jsx
import React from 'react';
import { Helmet } from 'react-helmet-async';
import LandingHeader from '../components/LandingHeader';
import LandingFooter from '../components/LandingFooter';
import '../styles/pages/PrivacyPolicyPage.scss';

const PrivacyPolicyPage = () => {
    return (
        <>
            <Helmet>
                <title>プライバシーポリシー - Suisui</title>
                <meta name="description" content="Suisuiのプライバシーポリシーをご確認ください。個人情報の取り扱いについて詳しく説明しています。" />
            </Helmet>

            <div className="privacy-policy-page">
                {/* ヘッダー */}
                <LandingHeader showNavButton={true} />

                {/* メインコンテンツ */}
                <div className="privacy-main">
                    <div className="container">
                        <div className="privacy-content">
                            <h1 className="privacy-title">プライバシーポリシー</h1>
                            <p className="privacy-updated">最終更新日: 2025年1月22日</p>

                            <div className="privacy-section">
                                <h2>1. 個人情報の取得について</h2>
                                <p>
                                    Suisui（以下「当サービス」）では、サービス提供のために以下の個人情報を取得いたします：
                                </p>
                                <ul>
                                    <li>Googleアカウントから取得される情報（メールアドレス、プロフィール情報）</li>
                                    <li>サービス利用に関する情報（作成されたコンテンツ、アクセスログ等）</li>
                                </ul>
                            </div>

                            <div className="privacy-section">
                                <h2>2. 個人情報の利用目的</h2>
                                <p>取得した個人情報は、以下の目的で利用いたします：</p>
                                <ul>
                                    <li>サービスの提供・運営</li>
                                    <li>ユーザー認証</li>
                                    <li>お客様からのお問い合わせへの対応</li>
                                    <li>サービスの改善・向上</li>
                                    <li>利用規約違反の対応</li>
                                </ul>
                            </div>

                            <div className="privacy-section">
                                <h2>3. 個人情報の第三者提供</h2>
                                <p>
                                    当サービスは、法令に基づく場合を除き、ご本人の同意なく個人情報を第三者に提供することはありません。
                                </p>
                            </div>

                            <div className="privacy-section">
                                <h2>4. 個人情報の保護</h2>
                                <p>
                                    当サービスは、個人情報を適切に管理し、紛失、破壊、改ざん、漏洩等を防止するため、
                                    必要かつ適切な安全管理措置を講じます。
                                </p>
                            </div>

                            <div className="privacy-section">
                                <h2>5. Cookieの使用について</h2>
                                <p>
                                    当サービスでは、サービスの利便性向上のためCookieを使用する場合があります。
                                    Cookieの使用を望まない場合は、ブラウザの設定で無効にすることができます。
                                </p>
                            </div>

                            <div className="privacy-section">
                                <h2>6. Google Analyticsの使用</h2>
                                <p>
                                    当サービスでは、Googleが提供するアクセス解析ツール「Google Analytics」を使用しています。
                                    Google Analyticsは、Cookieを使用してウェブサイトの利用状況を分析します。
                                </p>
                            </div>

                            <div className="privacy-section">
                                <h2>7. プライバシーポリシーの変更</h2>
                                <p>
                                    当サービスは、法令の変更等に伴い、本プライバシーポリシーを変更する場合があります。
                                    変更後のプライバシーポリシーは、当サイトに掲載した時点で効力を生じるものとします。
                                </p>
                            </div>

                            <div className="privacy-section">
                                <h2>8. お問い合わせ</h2>
                                <p>
                                    個人情報の取り扱いに関するお問い合わせは、当サービスのお問い合わせフォームよりご連絡ください。
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* フッター */}
                <LandingFooter />
            </div>
        </>
    );
};

export default PrivacyPolicyPage;
